import { Action } from 'redux';
import { ISubmissionHistory } from '../../services';

export enum BidHistoryActionEnum {
  FetchSubmissionHistory = '@@bid/FETCH_SUBMISSION_HISTORY',
  FetchedSubmissionHistorySuccessfully = '@@bid/FETCHED_SUBMISSION_HISTORY_SUCCESSFULLY',
  ClearSubmissionHistory = '@@bid/CLEAR_SUBMISSION_HISTORY',
}

export interface IBidHistoryState {
  isOpen?: boolean;
  submissionHistory?: ISubmissionHistory;
}

export interface IFetchSubmissionHistoryAction
  extends Action<typeof BidHistoryActionEnum.FetchSubmissionHistory> {
  state?: IBidHistoryState;
}

export interface IFetchedSubmissionHistorySuccessfullyAction
  extends Action<
    typeof BidHistoryActionEnum.FetchedSubmissionHistorySuccessfully
  > {
  state?: IBidHistoryState;
}

export interface IClearSubmissionHistoryAction
  extends Action<typeof BidHistoryActionEnum.ClearSubmissionHistory> {
  state?: IBidHistoryState;
}

export type BidHistoryActions =
  | IFetchSubmissionHistoryAction
  | IFetchedSubmissionHistorySuccessfullyAction
  | IClearSubmissionHistoryAction;
